import { render, staticRenderFns } from "./FedExCarrierForm.vue?vue&type=template&id=f8d0f74c"
import script from "./FedExCarrierForm.vue?vue&type=script&lang=js"
export * from "./FedExCarrierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports